import React from 'react';
import styles from './MainPage.css';

export type MainPageProps = {
  ref?: any;
  children: React.ReactNode;
  mainPageRef?: any;
};

const MainPage = ({ children, mainPageRef }: MainPageProps) => (
  <div className={styles.pageWrapper} ref={mainPageRef}>
    {children}
  </div>
);

export default MainPage;
